export const heroData = {
  mainCopy: ["AIやデジタルを、", "現場で使えるところまで。"],
  subCopy:
    "中小企業と地域団体の、身近なDX相談相手。課題の整理から導入、仕組みづくり、運用の定着まで継続して支援します。",
  targetAudiences: [
    { label: "中小企業・小規模事業者", icon: "ri-building-2-line" },
    { label: "店舗・商店街", icon: "ri-store-2-line" },
    { label: "社団法人・NPO・地域団体", icon: "ri-community-line" },
    { label: "会員組織・各種事務局", icon: "ri-group-line" },
  ],
};

export const supportData = {
  label: "WHO WE SUPPORT",
  title: "このような組織・事業者を支援しています",
  items: [
    {
      icon: "ri-building-2-line",
      title: "中小企業・小規模事業者",
      subtitle: "SMALL BUSINESS",
      intro:
        "社内にITやAIの担当者がおらず、業務改善について相談できる相手がいない。",
      problems: [
        "AIを使いたいが、何から始めるか分からない",
        "業務が特定の担当者に集中している",
        "複数のツールやファイルが整理されていない",
      ],
    },
    {
      icon: "ri-store-2-line",
      title: "店舗・商店街",
      subtitle: "SHOPS & DISTRICTS",
      intro:
        "日々の営業や地域活動を行いながら、情報発信や事務作業も少人数で担当している。",
      problems: [
        "予約や問い合わせ対応に時間がかかる",
        "イベント案内や加盟店への連絡が煩雑",
        "ホームページやSNSを十分に活用できていない",
      ],
    },
    {
      icon: "ri-community-line",
      title: "社団法人・NPO・地域団体",
      subtitle: "ORGANIZATIONS",
      intro:
        "限られた人員で、会員管理、申込受付、広報、情報共有などを行っている。",
      problems: [
        "会員情報や共有ファイルが整理されていない",
        "担当者が変わると業務が止まる",
        "紙やメール中心の運営から抜け出せない",
      ],
    },
    {
      icon: "ri-group-line",
      title: "会員組織・各種事務局",
      subtitle: "ASSOCIATIONS",
      intro:
        "同窓会、ロータリークラブ、経済人団体、業界団体など、会員との連絡や会議運営を担っている。",
      problems: [
        "案内文や議事録の作成に時間がかかる",
        "引き継ぎが難しく、業務が属人化している",
        "事務局担当者の負担が大きい",
      ],
    },
  ],
};

export const servicesData = {
  label: "SERVICES",
  title: "4つのサービス",
  items: [
    {
      id: "dx-consultant",
      badge: "月額顧問",
      title: "DX顧問",
      subtitle: "DX CONSULTANT",
      target: "社内にDX担当者がいない中小企業・小規模事業者へ",
      description:
        "社外のDX担当者として、業務課題の整理、改善提案、AI・ITツールの選定と定着を継続して支援します。",
      features: [
        "月次相談・定例ミーティング",
        "業務改善とツール選定",
        "AI・デジタル活用の定着支援",
      ],
      image:
        "https://readdy.ai/api/search-image?query=Japanese%20small%20business%20office%20interior%20with%20owner%20and%20consultant%20sitting%20at%20wooden%20desk%20reviewing%20laptop%20screen%20and%20paper%20documents%20together%2C%20two%20people%20having%20practical%20discussion%2C%20natural%20warm%20daylight%20from%20side%20window%2C%20modest%20bookshelf%20and%20filing%20cabinet%20in%20background%2C%20authentic%20lived-in%20workspace%20atmosphere%2C%20documentary%20editorial%20photography%20style%2C%20warm%20beige%20and%20brown%20tones%2C%20soft%20natural%20shadows%2C%20candid%20unposed%20expressions%2C%20no%20eye%20contact%20with%20camera&width=800&height=600&seq=service-dx-consultant-v2&orientation=landscape&nocache=true",
    },
    {
      id: "ai-office",
      badge: "伴走支援",
      title: "伴走型AI事務局サポート",
      subtitle: "AI OFFICE SUPPORT",
      target: "商店街、社団法人、NPO、同窓会、会員組織などの事務局へ",
      description:
        "事務局業務を代行し続けるのではなく、AIとデジタルを活用して、少人数でも無理なく回る仕組みを一緒につくります。",
      features: [
        "会議案内・議事録作成の効率化",
        "会員管理・情報共有の整理",
        "ホームページや申込受付の改善",
      ],
      image:
        "https://readdy.ai/api/search-image?query=Japanese%20community%20organization%20small%20office%20with%20three%20people%20of%20different%20ages%20including%20middle-aged%20and%20senior%20members%20gathered%20around%20desk%2C%20reviewing%20printed%20meeting%20agenda%20papers%20and%20member%20roster%20documents%2C%20open%20laptop%20on%20table%2C%20warm%20ceiling%20fluorescent%20light%20mixed%20with%20natural%20window%20light%2C%20bulletin%20board%20with%20flyers%20on%20wall%2C%20authentic%20local%20association%20atmosphere%2C%20documentary%20editorial%20photography%2C%20warm%20neutral%20tones%20with%20soft%20contrast%2C%20natural%20unposed%20interaction&width=800&height=600&seq=service-ai-office-v2&orientation=landscape&nocache=true",
    },
    {
      id: "ai-digital",
      badge: "初期導入",
      title: "AI・デジタル導入支援",
      subtitle: "AI & DIGITAL SETUP",
      target: "AIやデジタルツールを導入したいが、何から始めるか分からない組織へ",
      description:
        "現在の業務や利用環境を確認し、必要なツールの選定、初期設定、ルールづくり、研修まで支援します。",
      features: [
        "生成AI・Google Workspace導入",
        "AI利用ルールと業務フローの整備",
        "操作研修・活用支援",
      ],
      image:
        "https://readdy.ai/api/search-image?query=Japanese%20small%20office%20workspace%20where%20instructor%20sits%20beside%20a%20colleague%20at%20desk%2C%20both%20looking%20at%20laptop%20screen%20together%2C%20instructor%20pointing%20and%20explaining%20AI%20tool%20interface%20or%20Google%20Workspace%20on%20display%2C%20hands-on%20teaching%20moment%2C%20warm%20natural%20daylight%20through%20window%2C%20modest%20plant%20and%20office%20supplies%20on%20desk%2C%20supportive%20learning%20atmosphere%2C%20documentary%20editorial%20photography%2C%20warm%20soft%20tones%2C%20natural%20expressions%2C%20no%20posing%20or%20camera%20awareness&width=800&height=600&seq=service-ai-digital-v2&orientation=landscape&nocache=true",
    },
    {
      id: "business-tool",
      badge: "システム開発",
      title: "業務ツール・システム開発",
      subtitle: "TOOL & SYSTEM DEVELOPMENT",
      target: "既製サービスだけでは解決できない業務課題を持つ組織へ",
      description:
        "大規模なシステムではなく、実際の業務に必要な範囲で、運用しやすい小規模な仕組みを開発します。",
      features: [
        "チャットボット・FAQ",
        "申込・予約・会員管理",
        "Google Apps Scriptなどによる自動化",
      ],
      image:
        "https://readdy.ai/api/search-image?query=Japanese%20small%20business%20desk%20workspace%20top-down%20angled%20view%2C%20laptop%20displaying%20simple%20web%20application%20form%20interface%20on%20screen%2C%20handwritten%20workflow%20diagram%20and%20notes%20on%20paper%20beside%20computer%2C%20pen%20and%20coffee%20cup%20nearby%2C%20wireframe%20sketches%20on%20notepad%2C%20warm%20desk%20lamp%20ambient%20light%2C%20practical%20modest%20work%20environment%2C%20documentary%20product%20photography%2C%20warm%20neutral%20beige%20tones%2C%20soft%20natural%20shadows%2C%20organized%20but%20lived-in%20workspace&width=800&height=600&seq=service-tool-dev-v2&orientation=landscape&nocache=true",
    },
  ],
};

export const approachData = {
  label: "OUR APPROACH",
  title: "ノーブルラボのDX支援",
  intro:
    "DXとは、大きなシステムを導入することだけではありません。日々の仕事を少し楽にし、特定の人に依存せず、組織が無理なく活動を続けられる状態をつくることだと考えています。",
  points: [
    {
      num: "01",
      title: "課題の整理から始める",
      desc: "ツールを先に決めるのではなく、現在の業務や困りごとを確認します。",
    },
    {
      num: "02",
      title: "小さく始める",
      desc: "現在の環境、予算、人員に合わせて、無理のない範囲から改善します。",
    },
    {
      num: "03",
      title: "導入して終わらない",
      desc: "設定やシステム構築だけでなく、実際の業務で使える状態になるまで支援します。",
    },
    {
      num: "04",
      title: "相談と制作を分断しない",
      desc: "課題整理、提案、ウェブ制作、システム開発、運用支援まで一貫して対応します。",
    },
  ],
};

export const examplesData = {
  label: "EXAMPLES",
  title: "こんなご相談に対応します",
  items: [
    {
      category: "商店街事務局",
      problem: "会議案内と議事録作成が手間",
      support: "AIを活用した議事録自動作成と、一斉メール送信の仕組みを導入",
      goal: "月次事務作業を大幅削減",
    },
    {
      category: "会員組織",
      problem: "会員情報が散在し引き継ぎ困難",
      support: "Googleスプレッドシートへの移行とリアルタイム共有環境を構築",
      goal: "担当者変更時でも円滑な引き継ぎ",
    },
    {
      category: "小規模事業者",
      problem: "生成AIの導入方法が分からない",
      support: "ChatGPT・Geminiの導入と、社内ガイドラインの策定・研修実施",
      goal: "スタッフ全員が安心して活用できる環境",
    },
  ],
};

export const processData = {
  label: "PROCESS",
  title: "支援開始までの流れ",
  steps: [
    {
      num: "01",
      title: "相談・ヒアリング",
      desc: "何も決まっていない段階でも相談できます。現在の状況と困りごとを伺います。",
    },
    {
      num: "02",
      title: "課題整理・ご提案",
      desc: "優先すべき課題を整理し、支援内容、進め方、費用をご提案します。",
    },
    {
      num: "03",
      title: "導入・継続支援",
      desc: "必要な設定や仕組みづくりを行い、実際の業務で定着するまで支援します。",
    },
  ],
};

export const notesData = {
  label: "DX & AI NOTES",
  title: "DX・AI活用ノート",
  description: "現場で役立つDX・AIの活用方法や導入事例を発信しています。",
  items: [
    {
      category: "AI活用",
      title: "小規模事業者が生成AIを導入する手順",
      date: "2026.07.15",
      tags: ["生成AI", "導入手順"],
      summary:
        "生成AIの導入を検討している小規模事業者向けに、具体的な手順と注意点を解説します。",
    },
    {
      category: "環境構築",
      title: "Google Workspaceを導入する際の注意点",
      date: "2026.07.08",
      tags: ["Google Workspace", "導入支援"],
      summary:
        "Google Workspace導入時に陥りやすいトラブルと、事前に準備すべきポイントをまとめました。",
    },
    {
      category: "事務局効率化",
      title: "商店街・団体事務局の業務を効率化する方法",
      date: "2026.06.28",
      tags: ["事務局", "業務効率化"],
      summary:
        "少人数事務局向けに、AIとデジタルツールを活用した業務効率化の具体策を紹介します。",
    },
  ],
};

export const faqData = {
  label: "FAQ",
  title: "よくある質問",
  items: [
    {
      q: "DXについて何も決まっていなくても相談できますか？",
      a: "はい、大歓迎です。「何から始めればいいか分からない」という状態から一緒に考え、現状に合った第一歩を提案します。",
    },
    {
      q: "月額契約では何をしてもらえますか？",
      a: "月次ミーティングを中心に、業務課題の相談、ツール選定、改善提案、導入支援、定着フォローなどを継続的に行います。内容はご契約時にご希望を伺って調整します。",
    },
    {
      q: "単発の相談もできますか？",
      a: "はい、スポット相談も受け付けています。月額顧問契約に縛られず、必要な時に必要な分だけご利用いただけます。",
    },
    {
      q: "訪問対応は可能ですか？",
      a: "はい、近隣エリアであれば訪問対応も可能です。遠方の場合はオンラインでの支援が基本となります。",
    },
  ],
};

export const contactData = {
  heading: "DXについて、まずは気軽に相談してみませんか？",
  description:
    "具体的な導入内容が決まっていなくても問題ありません。現在の状況や困りごとを伺い、何から始めるべきか一緒に整理します。",
  inquiryTypes: [
    "DX顧問について",
    "伴走型AI事務局サポートについて",
    "AI・デジタル導入について",
    "業務ツール・システム開発について",
    "セミナー・講演について",
    "提携・紹介について",
    "その他",
  ],
};

export const footerData = {
  company: "株式会社ノーブルウェブ",
  department: "ノーブルラボのDX顧問",
  address: {
    postal: "〒166-0002",
    full: "東京都杉並区高円寺北2-18-7 千恵ビル401",
    company: "株式会社ノーブルウェブ",
    tel: "TEL:03-5356-8031",
  },
  links: {
    service: [
      { label: "DX顧問", href: "/service/dx-consultant" },
      { label: "伴走型AI事務局サポート", href: "/service/ai-office" },
      { label: "AI・デジタル導入支援", href: "/service/ai-digital" },
      { label: "業務ツール・システム開発", href: "/service/business-tool" },
    ],
    info: [
      { label: "私たちについて", href: "/about" },
      { label: "料金", href: "/pricing" },
      { label: "支援事例", href: "/cases" },
      { label: "DX・AI活用ノート", href: "/notes" },
      { label: "よくある質問", href: "/faq" },
    ],
    company: [
      { label: "会社概要", href: "/company" },
      { label: "お問い合わせ", href: "/contact" },
    ],
  },
  copyright: "© NOBLEWEB, Inc.",
};